/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminUpdatePermissionsRequest
 */
export interface AdminUpdatePermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdatePermissionsRequest
     */
    teamMemberId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdatePermissionsRequest
     */
    permission?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdatePermissionsRequest
     */
    value?: boolean;
}

export function AdminUpdatePermissionsRequestFromJSON(json: any): AdminUpdatePermissionsRequest {
    return AdminUpdatePermissionsRequestFromJSONTyped(json, false);
}

export function AdminUpdatePermissionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdatePermissionsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teamMemberId': !exists(json, 'teamMemberId') ? undefined : json['teamMemberId'],
        'permission': !exists(json, 'permission') ? undefined : json['permission'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function AdminUpdatePermissionsRequestToJSON(value?: AdminUpdatePermissionsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teamMemberId': value.teamMemberId,
        'permission': value.permission,
        'value': value.value,
    };
}


